import { createSlice } from "@reduxjs/toolkit";

const checklistNode_slice = createSlice({
  name: "checklistNode",
  initialState: [],
  reducers: {
    replaceChecklistNodeById: (state, action) => {
      const { id, newNode } = action.payload;
      state = state.map((node) => (node.id === id ? { ...newNode, id } : node));
    },
    set_checklist_node: (state, action) => action.payload,
    upsertChecklistNodeByStageId: (state, action) => {
      const newNode = action.payload;
      const existingIndex = state.findIndex(
        (node) => node.stage_id === newNode.stage_id
      );

      if (existingIndex !== -1) {
        state[existingIndex] = newNode; // Replace existing node
      } else {
        state.push(newNode); // Add new node
      }
    },
  },
});

export default checklistNode_slice.reducer;

export const {
  replaceChecklistNodeById,
  set_checklist_node,
  upsertChecklistNodeByStageId,
} = checklistNode_slice.actions;
